import React from 'react';
import {
  ArrowRight,
  BarChart3,
  Bell,
  Book,
  CreditCard,
  HelpCircle,
  ListChecks,
  Rocket,
  Settings as SettingsIcon,
} from 'lucide-react';

/**
 * Icon mapping for article categories
 */
const CATEGORY_ICONS = {
  'getting-started': Rocket,
  subscriptions: ListChecks,
  analytics: BarChart3,
  notifications: Bell,
  settings: SettingsIcon,
  billing: CreditCard,
  help: HelpCircle,
  default: Book,
};

/**
 * Color mapping for categories (gradient themes)
 */
const CATEGORY_COLORS = {
  'getting-started': 'blue',
  subscriptions: 'purple',
  analytics: 'green',
  notifications: 'orange',
  settings: 'gray',
  billing: 'cyan',
  help: 'indigo',
  default: 'blue',
};

/**
 * Help Featured Card Component
 *
 * Modern card with gradient border, icon, and hover effects.
 *
 * Why .hc-* classes instead of CSS modules: single source of truth in
 * resources/css/help-center.scss shared with Blade SSR.
 *
 * Location: resources/react/src/modules/help/components/help-featured-card.jsx
 *
 * @component
 *
 * @param {Object} props
 * @param {string} props.title - Card title
 * @param {string} props.description - Card description
 * @param {string} props.category - Category ID (for icon/color)
 * @param {Function} props.onClick - Click handler
 */
export const HelpFeaturedCard = ({ title, description, category, onClick }) => {
  const IconComponent = CATEGORY_ICONS[category] || CATEGORY_ICONS.default;
  const colorTheme = CATEGORY_COLORS[category] || CATEGORY_COLORS.default;

  return (
    <div
      className={`hc-featured-card hc-featured-card--${colorTheme}`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      role="button"
      tabIndex={0}
    >
      {/* Icon */}
      <div className="hc-featured-card__icon-wrapper">
        <IconComponent size={24} strokeWidth={2} />
      </div>

      {/* Content */}
      <div className="hc-featured-card__content">
        <h4 className="hc-featured-card__title">{title}</h4>
        <p className="hc-featured-card__description">{description}</p>
      </div>

      {/* Arrow (appears on hover) */}
      <div className="hc-featured-card__arrow">
        <ArrowRight size={20} strokeWidth={2} />
      </div>
    </div>
  );
};
